import { Col } from "react-bootstrap"
export const ProjectCard=({title, description, imgUrl})=>{
    return(
        <Col size={12} sm={6} md={4}>
            <div c>
                <img src={imgUrl}/>
                <div>
                    <h4>{title}</h4>
                    <span>{description}</span>
                </div>
            </div>
        </Col>
    )
}